const courses = [
  {
    type: "Offline",
    title: "Prelims cum Mains General Studies (Offline)",
    description:
      "Dive into the power-packed classroom sessions conducted by experienced mentors. This offline program offers a holistic approach to UPSC GS preparation.",
    img: "https://ideogram.ai/assets/progressive-image/balanced/response/_p98lbxESdqU_i7YTcSnUQ",
    badgeColor: "bg-red-600",
    textColor: "text-red-700",
    btnColor: "bg-red-600 hover:bg-red-700",
    features: [
      "Interactive teaching style with daily Q&A and critical discussions.",
      "Regular practice in answer-writing and presentation skills.",
      "Motivational sessions and weekly recap modules for sustained progress.",
      "Personal guidance to fine-tune exam strategy and mindset.",
    ],
  },
  {
    type: "Online",
    title: "Prelims cum Mains General Studies (Online)",
    description:
      "Learn from the comfort of your home with our fully digital GS program designed for remote learners who want flexibility without compromising on quality.",
    img: "https://images.unsplash.com/photo-1513258496099-48168024aec0?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8b25saW5lJTIwZXhhbXxlbnwwfDB8MHx8fDA%3D",
    badgeColor: "bg-blue-600",
    textColor: "text-blue-700",
    btnColor: "bg-blue-600 hover:bg-blue-700",
    features: [
      "Digital study packs, e-notes, and practice worksheets for self-paced revision.",
      "Active online community with peer discussion forums.",
      "Scheduled online tests with detailed performance analytics.",
      "Balanced structure for aspirants managing time alongside other commitments.",
    ],
  },
  {
    type: "Anthropology Optional",
    title: "Anthropology Optional",
    description:
      "Specialized classroom sessions with a focus on UPSC Anthropology. Designed to help aspirants understand concepts thoroughly and apply them effectively.",
    img: "https://ideogram.ai/assets/progressive-image/fast/response/Ro3YDNr8Rh20NZlovbg51w",
    badgeColor: "bg-red-600",
    textColor: "text-red-700",
    btnColor: "bg-red-600 hover:bg-red-700",
    features: [
      "Visual aids, case references, and diagram-based explanations for easy recall.",
      "Exclusive focus on UPSC-style questions and model answers.",
      "Continuous monitoring through weekly evaluation and feedback.",
      "Simplified approach to make Anthropology a high-scoring optional.",
    ],
  },
  {
    type: "CSAT",
    title: "CSAT Preparation (Offline)",
    description:
      "Focused sessions to help aspirants develop speed, accuracy, and problem-solving skills necessary for the CSAT exam.",
    img: "https://ideogram.ai/assets/progressive-image/balanced/response/UY1-VqaMQdSv4oRrS1AgzQ",
    badgeColor: "bg-red-600",
    textColor: "text-red-700",
    btnColor: "bg-red-600 hover:bg-red-700",
    features: [
      "Dedicated sessions on time-saving techniques and smart problem-solving.",
      "Varied practice sets with sectional tests for self-assessment.",
      "Daily short drills to build speed and accuracy consistently.",
      "Personalized strategies to help clear CSAT with minimal stress.",
    ],
  },
];

export default courses;
